// Importa dados mock dos arquivos JSON existentes
import mockCriticasData from '../mocks/criticas.json';
import mockNovidadesData from '../mocks/novidades.json';

// Função para simular delay de rede
const simulateNetworkDelay = () => {
  const delay = parseInt(process.env.REACT_APP_MOCK_DELAY) || 800;
  return new Promise(resolve => {
    setTimeout(resolve, delay);
  });
};

// Função para buscar dados (mock ou API real baseado na variável de ambiente)
export const fetchCriticas = async () => {
  // Detectar se está em desenvolvimento local
  const isLocalDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  
  // Verificar variável de ambiente (só funciona em desenvolvimento)
  const envUseMock = process.env.REACT_APP_USE_MOCK === 'true';
  
  // Em produção, sempre usar API real (ignorar variável de ambiente)
  const useMock = isLocalDevelopment && envUseMock;
  
  if (useMock) {
    console.log('🔧 Modo desenvolvimento: usando dados mock');
    await simulateNetworkDelay();
    return mockCriticasData;
  } else {
    console.log('🚀 Usando API real');
    
    try {
      const response = await fetch('/api/criticas');
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.error) {
        throw new Error(data.error);
      }
      
      return data;
    } catch (error) {
      // Em produção, não fazer fallback para mock
      if (!isLocalDevelopment) {
        throw error;
      }
      
      // Em desenvolvimento, fazer fallback para mock
      console.warn('⚠️ API real não disponível, usando mock como fallback:', error.message);
      await simulateNetworkDelay();
      return mockCriticasData;
    }
  }
};

// Função para buscar dados de novidades (mock ou API real baseado na variável de ambiente)
export const fetchNovidades = async () => {
  // Detectar se está em desenvolvimento local
  const isLocalDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  
  // Verificar variável de ambiente (só funciona em desenvolvimento)
  const envUseMock = process.env.REACT_APP_USE_MOCK === 'true';
  
  // Em produção, sempre usar API real (ignorar variável de ambiente)
  const useMock = isLocalDevelopment && envUseMock;
  
  if (useMock) {
    console.log('🔧 Modo desenvolvimento: usando dados mock para novidades');
    await simulateNetworkDelay();
    return mockNovidadesData;
  } else {
    console.log('🚀 Usando API real para novidades');
    
    try {
      const response = await fetch('/api/novidades');
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.error) {
        throw new Error(data.error);
      }
      
      return data;
    } catch (error) {
      // Em produção, não fazer fallback para mock
      if (!isLocalDevelopment) {
        throw error;
      }
      
      // Em desenvolvimento, fazer fallback para mock
      console.warn('⚠️ API real não disponível para novidades, usando mock como fallback:', error.message);
      await simulateNetworkDelay();
      return mockNovidadesData;
    }
  }
};
